import {FC} from 'react';
import {Box} from '@mui/material';
import AsideInfo from '@/components/Organization/Login/AsideInfo';
import LoginForm from '@/components/Organization/Login/LoginForm';
import {LoginFormValues} from '@/components/Organization/Login/LoginForm/formConfiguration';
import {organizationLogin} from '@/store/organization';
import {ROUTER_URL, USER_TYPE} from '@/utils/enums';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch} from '@/store/hooks';
import {getErrorMessage} from '@/utils/helpers';
import {organizationLoginStyle} from './OrganizationLogin.styles';
import {orgStorage} from '@/utils/services';

const OrganizationLogin: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const handleSubmitClickHandler = async (values: LoginFormValues) => {
		try {
			await dispatch(organizationLogin(values)).unwrap();
			orgStorage.set('userType', USER_TYPE.ORGANIZATION);

			navigate(ROUTER_URL.ORGANIZATION);
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	return (
		<Box sx={organizationLoginStyle.wrapper}>
			<Box sx={organizationLoginStyle.aside}>
				<AsideInfo />
			</Box>
			<Box sx={organizationLoginStyle.form}>
				<LoginForm handleSubmitClickHandler={handleSubmitClickHandler} />
			</Box>
		</Box>
	);
};

export default OrganizationLogin;
